import { render, staticRenderFns } from "./personalDataModal.vue?vue&type=template&id=140d0b80"
import script from "./personalDataModal.vue?vue&type=script&lang=js"
export * from "./personalDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports